import { getToken } from './authToken'
/**
 * Async status check passed to ProtectedRoute's `statusCheck` prop.
 *
 * Calls /api/tenants/current to verify the tenant is active. Returns a
 * block-reason string on suspension/disabling, or null if access is allowed.
 *
 * Network/unexpected errors return null — child components handle them.
 */
export async function checkTenantStatus(): Promise<string | null> {
  const token = getToken()
  if (!token) return null

  try {
    const res = await fetch('/api/tenants/current', {
      headers: { Authorization: `Bearer ${token}` },
    })
    if (res.status === 403) {
      const body = await res.json().catch(() => ({}))
      const code = body?.code as string | undefined
      if (code === 'TENANT_SUSPENDED' || code === 'TENANT_DISABLED') {
        return code
      }
    }
  } catch {
    // Ignore — don't block on network failures
  }
  return null
}
